import AccountBalanceIcon from '@material-ui/icons/AccountBalance'
import AccountTreeIcon from '@material-ui/icons/AccountTree'
import BuildIcon from '@material-ui/icons/Build'
import EmojiTransportationIcon from '@material-ui/icons/EmojiTransportation'
import FileCopyIcon from '@material-ui/icons/FileCopy'
import HomeWorkIcon from '@material-ui/icons/HomeWork'
import LocalAtmIcon from '@material-ui/icons/LocalAtm'
import LocalHospitalIcon from '@material-ui/icons/LocalHospital'
import MultilineChartIcon from '@material-ui/icons/MultilineChart'
import PaymentIcon from '@material-ui/icons/Payment'
import StorageIcon from '@material-ui/icons/Storage'
import TransitEnterexitIcon from '@material-ui/icons/TransitEnterexit'
import React, { useState, useEffect } from 'react'
import Spinner from 'react-bootstrap/Spinner'
import { connect, useDispatch } from 'react-redux'
import { Redirect, withRouter } from 'react-router-dom'
import {
  flushMenuTree,
  hideLoader,
  navUrl,
  navigateToModule,
  setMenuTree,
  showLoader
} from '../../redux/Common/commonActions'
import { loadModules } from '../../redux/Interactions/interactionsActions'
import './apps.css'
import store from '../../store'
import { getRequest } from '../../globalhelper/helper'
import { Box, Card, CardActionArea, Grid, Typography } from '@mui/material'
import { alpha } from '@material-ui/core'

// Mapping shortkeys to icons
const iconMapping = {
  Lease: FileCopyIcon,
  Enterprise_Configurations: BuildIcon,
  Finance_APIs: TransitEnterexitIcon,
  Financial_Instruments: LocalAtmIcon,
  HIS_Inventory_Management: LocalHospitalIcon,
  P2P_Application: MultilineChartIcon,
  ERP_Materials_Management_APIs: StorageIcon,
  FixedAsset: EmojiTransportationIcon,
  OneCommerce: AccountTreeIcon,
  OneRetail: HomeWorkIcon,
  COD: PaymentIcon,
  DTFOWS: AccountBalanceIcon
}

const MyApps = props => {
  const getModuleIcon = shortkey => {
    for (let key in iconMapping) {
      if (shortkey.includes(key)) {
        return iconMapping[key]
      }
    }
    return null
  }

  const [state, setState] = useState({
    alert: '',
    modules: [],
    redirect: null,
    noModules: false,
    gotKey: false
  })
  let dispatch = useDispatch()

  useEffect(() => {
    let isMounted = true
    sessionStorage.setItem('module_desc_for_ui_only', 'My Apps')
    sessionStorage.setItem('pageName', '')

    const getModules = async () => {
      try {
        dispatch(showLoader())
        const STATE = store.getState()
        let response = await getRequest(
          'api/module/modules?tenant_id=' + STATE.login.userData.USR_Tenant
        )
        if (isMounted) {
          setState(prevState => ({ ...prevState, modules: response.res.data }))
        }
      } catch (e) {
        console.log(e)
      } finally {
        if (isMounted) {
          dispatch(hideLoader())
        }
      }
    }

    getModules()

    return () => {
      isMounted = false
    }
  }, [dispatch])

  const navigate = module => {
    store.dispatch(navigateToModule(module))
  }

  if (state.redirect) {
    return <Redirect to={state.redirect} />
  }

  return (
    <Box
      sx={{
        p: { xs: 2, sm: 4 },
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#f8fafc' // Light slate background
      }}
    >
      <Typography variant='h4' sx={{ mb: 4, fontWeight: 800, color: '#1e293b', textAlign: 'center' }}>
        My Apps
      </Typography>

      {state.modules && state.modules.length > 0 ? (
        <Grid container spacing={3} sx={{ maxWidth: 1200, justifyContent: 'center' }}>
          {state.modules.map((module, index) => {
            const Icon = getModuleIcon(module.shortkey)
            return (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Card
                  sx={{
                    borderRadius: '20px',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.04)',
                    border: '1px solid rgba(0,0,0,0.05)',
                    transition: 'all 0.3s ease',
                    height: '100%',
                    '&:hover': {
                      transform: 'translateY(-8px)',
                      boxShadow: '0 12px 30px rgba(0,0,0,0.08)',
                      borderColor: '#7c3aed'
                    }
                  }}
                >
                  <CardActionArea
                    onClick={() => navigate(module)}
                    sx={{
                      height: '100%',
                      p: 3,
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      textAlign: 'center'
                    }}
                  >
                    <Box
                      sx={{
                        width: 80,
                        height: 80,
                        borderRadius: '24px',
                        backgroundColor: alpha('#7c3aed', 0.1),
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mb: 3,
                        color: '#7c3aed'
                      }}
                    >
                      {Icon && <Icon sx={{ fontSize: 40 }} />}
                    </Box>

                    <Typography
                      variant='h6'
                      sx={{ color: '#1e293b', fontWeight: 700, mb: 1 }}
                    >
                      {module.shortkey === 'OneRetail'
                        ? '26AS Reconciler'
                        : module.shortkey === 'OneCommerce'
                          ? 'Payouts'
                          : module.shortkey.split('_').join(' ')}
                    </Typography>

                    <Typography
                      variant='body2'
                      sx={{ color: '#64748b', mb: 2, lineHeight: 1.6 }}
                    >
                      {module.name}
                    </Typography>

                    <Box sx={{
                      mt: 'auto',
                      display: 'flex',
                      alignItems: 'center',
                      color: '#7c3aed',
                      fontWeight: 600,
                      fontSize: '0.875rem'
                    }}>
                      Open App <span style={{ marginLeft: '4px' }}>→</span>
                    </Box>
                  </CardActionArea>
                </Card>
              </Grid>
            )
          })}
        </Grid>
      ) : (
        state.noModules && (
          <div className='row'>
            <div
              className='col-md-12'
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '80vh'
              }}
            >
              <h4>You don't have access for any modules!</h4>
            </div>
          </div>
        )
      )}

      {state.alert}
    </Box>
  )
}

const mapStateToProps = state => {
  return {
    store: state
  }
}

export default withRouter(
  connect(mapStateToProps, {
    navUrl,
    setMenuTree,
    flushMenuTree,
    loadModules,
    navigateToModule
  })(MyApps)
)
